import React from 'react';
import './App.css';
import store from './store';
import { Provider } from 'react-redux';
import Routes from './routes/routes';
 
function App() {
  return (
    <div className="App">
      <Provider store={store}>
         <Routes/>
      </Provider>
      
    
    </div>
  );
}

export default App;
